import axios from "axios";
import { API_BASE_URL } from "../../config";

const BASE = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

export const getBalanceSheetComparison = async (numYears = 5) => {
  try {
    const response = await axios.get(`${BASE}/reports/balance-sheet-comparison`, {
      params: { num_years: numYears },
    });
    return response.data;
  } catch (error) {
    console.warn("Primary endpoint failed, trying fallback /financials/balance-sheet-comparison...", error);
    try {
      const fallback = await axios.get(`${BASE}/financials/balance-sheet-comparison`, {
        params: { num_years: numYears },
      });
      return fallback.data;
    } catch (fallbackError) {
      console.error("Error fetching Balance Sheet comparison:", fallbackError);
      throw fallbackError;
    }
  }
};
